import { Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

export const HunterDescription = () => {
  const { t } = useResource();

  return (
    <Stack gap={2} sx={{ "& strong": { fontWeight: 500, mr: 1 } }}>
      <Typography variant="h6">
        {t(Resources.Onboarding.HunterDescription.Welcome)}
      </Typography>
      <Typography>
        {t(Resources.Onboarding.HunterDescription.IdentityVerificationRequired)}
      </Typography>
      <Typography>
        <Typography component="strong">
          {t(Resources.Onboarding.HunterDescription.HCRMDescription)}
        </Typography>
        {t(Resources.Onboarding.HunterDescription.HCRMWorkEnvironment)}
      </Typography>
      <Typography>
        <Typography component="strong">
          {t(Resources.Onboarding.HunterDescription.RemoteContractVerification)}
        </Typography>
        {t(Resources.Onboarding.HunterDescription.VerificationPrinciple)}
      </Typography>
      <Typography>
        {t(Resources.Onboarding.HunterDescription.DocumentSecurity)}
      </Typography>
      <Typography>
        <Typography component="strong">
          {t(Resources.Onboarding.HunterDescription.QuickProcessAndWelcome)}
        </Typography>
      </Typography>
    </Stack>
  );
};
